"use client";
import {
  useCompositeRow
} from "../__chunks/TR2S63FJ.js";
import {
  useSelectContext
} from "../__chunks/OFHTR2QK.js";
import "../__chunks/RA2MZPUM.js";
import "../__chunks/J4JPXPLD.js";
import "../__chunks/THGRQCVD.js";
import "../__chunks/UUT76IPH.js";
import "../__chunks/JS4W7WDG.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/I6MSISV2.js";
import "../__chunks/FPBGCFAS.js";
import "../__chunks/KQWO6ME3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/select/select-row.tsx
import { getPopupRole } from "@ariakit/core/utils/dom";
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "div";
var useSelectRow = createHook(
  function useSelectRow2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useSelectContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "SelectRow must be wrapped in a SelectList or SelectPopover component"
    );
    const listElement = store.useState("listElement");
    const popupRole = getPopupRole(listElement);
    const role = popupRole === "grid" ? "row" : "presentation";
    props = __spreadValues({ role }, props);
    props = useCompositeRow(__spreadValues({ store }, props));
    return props;
  }
);
var SelectRow = forwardRef(function SelectRow2(props) {
  const htmlProps = useSelectRow(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectRow,
  useSelectRow
};
